@import "@/ui/variables.css";

.calloutRoot {
  --background: var(--gray-light);

  padding: var(--space-2) var(--space-3);

  background-color: oklch(from var(--background) calc(l - 0.14) calc(c - 0.03) h);
  border: var(--border);

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);

  cursor: pointer;
  animation: slideDown 150ms 1 ease-in;

  &[data-variant="notice"] {
    --background: var(--green);
  }

  &[data-variant="alert"] {
    --background: var(--red);
  }

  &[data-dismissed="true"] {
    transform: translateY(-100%);
    animation: slideUp 150ms 1 ease-in;
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slideUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
    top: -100%;
  }
}
